const _ = require('lodash');

export default {
  data: (state) => {
    return state.data
  },
  job_category: (state) => {
    return state.data.job_category
  },
  job_category_id: (state) => {
    return state.data.job_category_id
  },
  job_category_ids: (state) => {
    return state.data.job_category_ids
  },
}
